import React, { useState, useEffect } from 'react';

const textContent = [
  {
    title: "Collaborate And Hire Fast",
    subtitle: "Work together with your team to make better hiring decisions"
  },
  {
    title: "Find Your Next Team Member Fast",
    subtitle: "Streamline your hiring process with intelligent assessment tools"
  },
  {
    title: "Assess Candidates With Video",
    subtitle: "Get deeper insights with video responses and AI-powered evaluation"
  }
];

const staticImage = "/lovable-uploads/6942857d-3f06-4316-94e2-2fc64e3b2e9a.png";

export function AuthSlideshow() {
  const [currentText, setCurrentText] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentText((prev) => (prev + 1) % textContent.length);
    }, 30000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full h-full overflow-hidden">
      {/* Static Background Image */}
      <div className="absolute inset-0">
        <div
          className="w-full h-full bg-cover bg-center relative"
          style={{ backgroundImage: `url(${staticImage})` }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/60" />
          
          {/* Rotating Text Content */}
          <div className="absolute bottom-0 left-0 right-0 p-16 text-white">
            <h2 className="text-4xl font-bold mb-2 leading-tight transition-opacity duration-1000 drop-shadow-lg">
              {textContent[currentText].title}
            </h2>
            <p className="text-xl text-white/95 leading-relaxed transition-opacity duration-1000 drop-shadow-md font-medium">
              {textContent[currentText].subtitle}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}